<template>
  <div :class="$options.name">
    <v-card :loading="isLoading" width="800px">
      <role-form
        v-model="form"
        :data="single"
        :permissions-list="permissionsList"
        :regions-list="regionsList"
        :roles-list="rolesList"
        is-edit
        @submit="onSave"
      />
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RoleForm from './components/RoleForm.vue';

export default {
  name: 'roles-item-view',
  asyncData({ store, route }) {
    const { id } = route.params;

    const actions = [
      store.dispatch('permissions/searchSelect/getList'),
      store.dispatch('regions/searchSelect/getList'),
      store.dispatch('roles/searchSelect/getList'),
      store.dispatch('roles/getItem', id),
    ];

    return Promise.all(actions);
  },
  components: { RoleForm },
  data: () => ({
    form: null,
    isLoading: false,
  }),
  computed: {
    ...mapState('roles', ['single']),
    ...mapState('permissions/searchSelect', {
      permissionsList: 'list',
    }),
    ...mapState('regions/searchSelect', {
      regionsList: 'list',
    }),
    ...mapState('roles/searchSelect', {
      rolesList: 'list',
    }),
  },
  methods: {
    ...mapActions('roles', ['update']),
    ...mapActions(['showNotify']),

    async onSave() {
      this.isLoading = true;
      await this.update(this.form);
      this.showNotify({ message: 'Роль успешно обновлена' });

      this.isLoading = false;
    },
  },
};
</script>
